module.exports = __webpack_public_path__ + "img/banana.53ce458f.svg";